import { Truck, Store, Crown, ChevronRight } from "lucide-react";

const ZONE_CONFIG = {
  food_truck: {
    icon: Truck,
    name_en: "Arena Garden",
    name_pl: "Arena Garden",
    desc_en: "Food truck zone",
    desc_pl: "Strefa foodtruck",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_venue-dining-1/artifacts/zk0gqxer_Arena%20Garden%20-%20g%C5%82%C3%B3wne.jpeg",
    gradient: "from-orange-900/80 via-orange-900/50 to-transparent",
    accent: "bg-orange-500",
  },
  kiosk: {
    icon: Store,
    name_en: "SnackBar",
    name_pl: "SnackBar",
    desc_en: "Gastronomic points",
    desc_pl: "Punkty gastronomiczne",
    image: "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/uw0hmbuv_Kiosk.jpg",
    gradient: "from-slate-900/80 via-slate-900/50 to-transparent",
    accent: "bg-blue-500",
  },
  vip: {
    icon: Crown,
    name_en: "VIP Restaurants",
    name_pl: "Restauracje VIP",
    desc_en: "Premium dining experience",
    desc_pl: "Restauracje premium",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_venue-dining-1/artifacts/gacxgr4x_g%C5%82%C3%B3wne%20restauracja.jpg",
    gradient: "from-amber-900/80 via-amber-900/50 to-transparent",
    accent: "bg-amber-500",
  },
};

export const ZoneHeroCards = ({ zoneCounts, language, onSelectZone, t }) => {
  const zones = ["vip", "kiosk", "food_truck"];

  return (
    <div className="space-y-3 px-4 py-4">
      {zones.map((zone, idx) => {
        const config = ZONE_CONFIG[zone];
        const Icon = config.icon;
        const name = language === "pl" ? config.name_pl : config.name_en;
        const desc = language === "pl" ? config.desc_pl : config.desc_en;

        return (
          <button
            key={zone}
            data-testid={`zone-hero-${zone}`}
            onClick={() => onSelectZone(zone)}
            className="w-full rounded-2xl overflow-hidden relative group active:scale-[0.98] transition-transform animate-fade-in-up block text-left"
            style={{ animationDelay: `${idx * 0.1}s` }}
          >
            {/* Background image */}
            <div className="relative h-44 sm:h-48">
              <img
                src={config.image}
                alt={name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              {/* Gradient overlay */}
              <div className={`absolute inset-0 bg-gradient-to-r ${config.gradient}`} />
              
              {/* Content overlay */}
              <div className="absolute inset-0 flex items-end p-5">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1.5">
                    <div className={`w-8 h-8 rounded-lg ${config.accent} flex items-center justify-center`}>
                      <Icon size={16} className="text-white" />
                    </div>
                  </div>
                  <h2 className="text-white text-xl sm:text-2xl font-bold leading-tight">
                    {name}
                  </h2>
                  <p className="text-white/70 text-sm mt-0.5">
                    {desc}
                  </p>
                </div>
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center group-hover:bg-[#dd260e] transition-colors shrink-0 ml-3">
                  <ChevronRight size={20} className="text-white" />
                </div>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export { ZONE_CONFIG };
